import * as React from 'react';
import styles from './close-button.module.scss';
import { closeSvg } from '../../../ui-icons/navbar-icons';

export interface ICloseButtonProps {
    label?: string;
    onClick: () => void;
}

export const CloseButton: React.FC<ICloseButtonProps> = (props) => (
    <div className={styles.button} onClick={props.onClick}>
        {props.label && <span>{props.label}</span>}
        {closeSvg}
    </div>
);
